import React, { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { hideLoader, showLoader } from '../../components/loader';
import { createFormdataValues } from '../../utils/createFormdataValues';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import ErrorMessage from '../../components/errors/errorMessage';
import { apiUrl } from '../../utils/url';
import useDebounce from '../../services/useDebounce';
import plus from '../../assets/img/plus.svg';

const ImportBrandModal = ({ show, setShow, endpoint, successFunction }) => {
    const [error, setError] = useState([]);
    const [value, setValue] = useState({});
    const { slug } = useSelector(state => state?.slugReducer);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const suggestionRefs = useRef([]); // Stores refs for each suggestion
    const debouncedValue = useDebounce(value?.website_url, 500);
    const fetchLogoSuggestions = async (domain) => {
        if (!domain) {
            setSuggestions([]);
            setIsFetching(false);
            return;
        }

        setIsFetching(true);
        try {
            const response = await fetch(`https://autocomplete.clearbit.com/v1/companies/suggest?query=${domain}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            setSuggestions(data);
        } catch (error) {
            console.error('Error fetching domain suggestions:', error);
            setSuggestions([]);
            setShowSuggestions(false);
        } finally {
            setIsFetching(false);
        }
    };
    const handleClose = () => {
        setValue(null);
        setShow(null);
    }
    const handleChange = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value });
        if (e.target.name == 'website_url' && e.target.value?.length > 0) {
            setShowSuggestions(true);
        }
    }
    const handleSubmit = (e) => {
        setError([]);
        e?.preventDefault();
        var api = apiUrl + endpoint;
        showLoader()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const formdata = createFormdataValues(value);
        formdata.append("project", slug);

        const setOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
        }
        fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    handleClose();
                    successFunction(response);
                    hideLoader();
                    toast.success(response?.status_message)
                } else {
                    toast.error(response?.status_message)
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                        $(".modal-body").scrollTop(0);
                    hideLoader();
                }
                hideLoader();
            }).catch(() => {
                hideLoader();
            });
    }
    useEffect(() => {
        if (debouncedValue) {
            fetchLogoSuggestions(debouncedValue);
        } else {
            setSuggestions([]);
        }
    }, [debouncedValue]);
    const handleSuggestionSelect = (suggestion) => {
        const selectedDomain = suggestion?.domain;
        setValue({
            ...value,
            website_url: selectedDomain,
            website_logo: suggestion?.logo,
            website_name: suggestion?.name,
        });
        setShowSuggestions(false);
    };
    const handleCloseSuggestions = () => {
        setTimeout(() => {
            setSelectedIndex(0);
            setShowSuggestions(false);
        }, 500);
    };
    const scrollToView = (index) => {
        if (suggestionRefs.current[index]) {
            suggestionRefs.current[index].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest', // Keeps the selected item in view
            });
        }
    };
    return (
        <Modal centered show={show} onHide={handleClose} className="rename-modal">
            <div class="modal-content pt-0 pl-0 pr-0 pb-0 border-0 ">
                <div class="modal-header">
                    Import Brand
                    <button type="button" class="close" onClick={handleClose} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form action="" id="" method="post" role="form" onSubmit={handleSubmit}>
                        <ErrorMessage error={error} />
                        <div className='form-group'>
                            {!value?.website_logo &&
                                <input required type='text' autoComplete='off' onChange={handleChange} onBlur={handleCloseSuggestions} onFocus={() => setShowSuggestions(true)} placeholder='domain.com' name='website_url' className='zaapGlobal-input h-30px bg-f3f3f3' value={value?.website_url} onKeyDown={(e) => {
                                    if (e.key === "ArrowDown") {
                                        e.preventDefault();
                                        setSelectedIndex((prev) => {
                                            const nextIndex = prev < suggestions.length ? prev + 1 : 0; // Include static option
                                            scrollToView(nextIndex); // Scroll the selected item into view
                                            return nextIndex;
                                        });
                                    } else if (e.key === "ArrowUp") {
                                        e.preventDefault();
                                        setSelectedIndex((prev) => {
                                            const nextIndex = prev > 0 ? prev - 1 : suggestions?.length;
                                            scrollToView(nextIndex); // Scroll the selected item into view
                                            return nextIndex;
                                        });
                                    } else if (e.key === "Enter") {
                                        e.preventDefault();
                                        if (selectedIndex >= 0 && suggestions.length > 0) {
                                            handleSuggestionSelect(suggestions[selectedIndex]);
                                        }else if (selectedIndex === suggestions.length) {
                                            handleSuggestionSelect({domain:e.target.value});
                                        }
                                    }
                                }} />
                            }
                            {value?.website_url && showSuggestions && (
                                <div className="custom-scrollbar shadow mt-1 domains-dropdown">
                                    {isFetching ? (
                                        <div className="ps-2 fs-12 text-gray font-weight-500">Loading...</div>
                                    ) : suggestions.length > 0 ? (
                                        <>
                                            <div className='ps-2 fs-12 text-gray font-weight-500'>Results</div>
                                            {suggestions.map((suggestion, index) => (
                                                <div
                                                    key={index}
                                                    ref={(el) => (suggestionRefs.current[index] = el)} 
                                                    onClick={() => handleSuggestionSelect(suggestion)}
                                                    className={`domains-dropdown-item ${selectedIndex === index ? 'active' : ''}`}
                                                    >
                                                    {suggestion?.logo && (
                                                        <img
                                                            src={suggestion?.logo}
                                                            alt={`${suggestion?.name} logo`}
                                                            width={20}
                                                            height={20}
                                                            className="mr-3 rounded object-fit-contain"
                                                        />
                                                    )}
                                                    <div className='d-flex justify-content-between align-items-center w-100 gap-3'>
                                                        <div className="domains-dropdown-name font-weight-bold fs-14px text-truncate">
                                                            {suggestion?.name}
                                                        </div>
                                                        <div className="text-gray small text-truncate">{suggestion?.domain}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    ) : (
                                        <div className="ps-2 text-gray fs-12">No results found</div>
                                    )}
                                    <div ref={(el) => (suggestionRefs.current[suggestions.length] = el)} className={`domains-dropdown-item fs-12  gap-1 ${selectedIndex === suggestions?.length ? 'active' : ''}`} onClick={() => handleSuggestionSelect({domain:value?.website_url})}>
                                       <img className='filter-invert-1' width={9} src={plus} alt="" srcset="" /> Add {value?.website_url}
                                    </div>
                                </div>
                            )}
                            {value?.website_logo && value?.website_name && value?.website_url && (
                                <div className="zaapGlobal-input mt-2 d-flex justify-content-between align-items-center w-100 gap-2 py-1 h-30px" >
                                    {value?.website_logo && (
                                        <img
                                            src={value?.website_logo}
                                            alt={`${value?.website_name} logo`}
                                            width={20}
                                            height={20}
                                            className="mr-3 rounded object-fit-contain"
                                        />
                                    )}
                                    <div className='d-flex align-items-center justify-content-between w-100'>
                                        <div className="fs-12 domains-dropdown-name font-weight-bold text-truncate">
                                            {value?.website_name}
                                        </div>
                                        <div className="text-gray small text-truncate">{value?.website_url}</div>
                                    </div>
                                    <button className="btn btn-icon btn-sm text-gray p-0 fs-12" onClick={() =>
                                        setValue({ ...value, website_url: value?.website_url, website_logo: '', website_name: '' })
                                    }>
                                        ✖
                                    </button>
                                </div>
                            )}
                            {/* <input type="text" name="name" onChange={handleChange} className='zaapGlobal-input h-30px bg-f3f3f3' value={value?.name} /> */}
                        </div>
                        <div className='d-flex gap-2 mt-20px p-0 align-items-center justify-content-center new-modal-footer'>
                            <button onClick={handleClose} className='fs-12 w-50 mt-0 integration-btns integration-btn-grey' type='button'>Cancel</button>
                            <button className='fs-12 w-50 shadow-none  project-blue-btn' type='submit'>Import</button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    )
}

export default ImportBrandModal